import { SLUGS } from '@/commons/constants';
import { MenuProps } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

export type MenuDataItemType = {
  title: string;
  key: string;
  url?: string;
  icon?: React.ReactNode;
  children?: MenuDataItemType[];
  regex?: RegExp;
  hidden?: boolean;
  permissions?: string[];
  parent?: string;
} & MenuItem;

const menuData: MenuDataItemType[] = [
  {
    title: 'Dashboard',
    key: 'dashboard',
    url: SLUGS.DASHBOARD,
    icon: <i className="fas fa-tachometer-alt"></i>,
  },
  {
    title: 'Manage',
    key: 'manage-group',
    icon: <i className="fas fa-pencil-ruler" />,
    children: [
      {
        key: 'brands',
        title: 'Brand Info',
        url: SLUGS.BRANDS_MANAGEMENT,
        icon: <i className="fa-solid fa-info" />,
        parent: 'manage-group',
      },
      {
        key: 'showrooms',
        title: 'Showrooms',
        url: SLUGS.SHOWROOMS_MANAGEMENT,
        icon: <i className="fa-solid fa-shop"></i>,
        parent: 'manage-group',
      },
      {
        key: 'products',
        title: 'Products',
        url: SLUGS.PRODUCTS_MANAGEMENT,
        icon: <i className="fa-solid fa-box"></i>,
        parent: 'manage-group',
      },
      {
        key: 'agents',
        title: 'Agents',
        url: SLUGS.AGENTS_MANAGEMENT,
        icon: <i className="fa-solid fa-robot"></i>,
        parent: 'manage-group',
      },
    ],
  },
];

export default menuData;
